import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  commonZH, commonEN, commonJA,
  modalZH, modalEN, modalJA,
  lineZH, lineEN, lineJA,
  resourceLimitZH, resourceLimitEN, resourceLimitJA
} from '@redpanda/common-locales';
import { deepMerge, createI18nInitConfig } from '@redpanda/utils';

// 本地翻譯檔案
import enTranslation from './locales/en/translation.json';
import zhTranslation from './locales/zh/translation.json';
import jaTranslation from './locales/ja/translation.json';

// 將 common-locales 的結構轉換為扁平結構
function flattenCommonLocales(common: any) {
  return {
    add: common.actions?.add,
    edit: common.actions?.edit,
    delete: common.actions?.delete,
    save: common.actions?.save,
    cancel: common.actions?.cancel,
    confirm: common.actions?.confirm,
    view: common.actions?.view,
    close: common.actions?.close,
    back: common.actions?.back,
    search: common.actions?.search,
    filter: common.actions?.filter,
    reset: common.actions?.reset,
    submit: common.actions?.submit,
    update: common.actions?.update,
    create: common.actions?.create,
    refresh: common.actions?.refresh,
    loading: common.status?.loading,
    saving: common.status?.saving,
    name: common.table?.columns?.name,
    phone: common.table?.columns?.phone,
    status: common.table?.columns?.status,
    actions: common.table?.columns?.actions,
    messages: common.messages,
    noData: common.messages?.noData,
    noResults: common.messages?.noResults,
    confirmDelete: common.messages?.confirmDelete,
    footer: common.footer,
  };
}

function mergeTranslations(common: any, line: any, local: any) {
  const flattenedCommon = flattenCommonLocales(common);
  const merged = {
    ...local,
    common: deepMerge(flattenedCommon, local.common || {}),
  };
  // 共用 LINE 翻譯作為基底，本地 key 覆蓋
  if (merged.queue?.settings?.lineIntegration) {
    merged.queue.settings.lineIntegration = deepMerge(line, merged.queue.settings.lineIntegration);
  }
  return merged;
}

const resources = {
  en: {
    translation: mergeTranslations(commonEN, lineEN, enTranslation),
    modal: modalEN,
    resourceLimit: resourceLimitEN,
  },
  zh: {
    translation: mergeTranslations(commonZH, lineZH, zhTranslation),
    modal: modalZH,
    resourceLimit: resourceLimitZH,
  },
  ja: {
    translation: mergeTranslations(commonJA, lineJA, jaTranslation),
    modal: modalJA,
    resourceLimit: resourceLimitJA,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(createI18nInitConfig({ resources }));

export default i18n;
